import React from "react";

function EmptyRow() {
  return <div className="col-md-2" />;
}

export default EmptyRow;
